export enum OAuthVendor {
  Slack = 'slack'
}
